var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-list',{attrs:{"type":'report',"columnsData":_vm.columnsData}})
}
var staticRenderFns = []

export { render, staticRenderFns }